import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import upperBackPainLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const PhysiotherapyTreatmentAndExercisesForUpperBackPain = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Expert Relief for Upper Back Pain</h1>
                    <h2>Unlock the secrets to overcoming upper back pain with targeted physiotherapy treatment and exercises at Ramp Physio and Fitness.</h2>
                    <p>Upper back pain can significantly impact your daily life, causing discomfort and limiting your mobility. At Ramp Physio and Fitness, we specialize in providing effective physiotherapy treatment and exercises specifically designed to alleviate upper back pain. Our approach is tailored to your unique needs, ensuring that you receive the most appropriate care to help you return to a pain-free lifestyle. In this comprehensive guide, we'll delve into the causes of upper back pain and share our expertise on how to effectively manage and treat it.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Understanding Upper Back Pain</h1>
                        <p>Upper back pain, often experienced between the base of the neck and the bottom of the rib cage, can arise from a variety of causes such as poor posture, muscle overuse, injury, or even stress. Recognizing the underlying factors is crucial in developing an effective treatment plan. Our skilled physiotherapists at Ramp Physio and Fitness are experts in diagnosing and addressing the specific source of your upper back pain.</p>
                        <p>By conducting a thorough assessment, we tailor a treatment strategy that may include manual therapy, therapeutic exercises, and advice on posture and ergonomics. Our goal is to not only relieve your pain but also to prevent its recurrence.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/dumbbells.webp" alt="Exercise" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Personalized Physiotherapy Techniques</h1>
                    <p>Each individual's experience with upper back pain is unique, which is why we offer personalized physiotherapy techniques. These may include hands-on manual therapy to mobilize stiff joints and release tight muscles, as well as specific therapeutic exercises aimed at strengthening and stabilizing the upper back.</p>
                    <p>We emphasize the importance of a personalized exercise regimen that targets the muscles supporting the thoracic spine. This can greatly enhance your recovery and help maintain a healthy upper back.</p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={upperBackPainLogo} alt="Upper Back Pain Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>

            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Therapeutic Exercise Selection</h1>
                    <p>Therapeutic exercises form the cornerstone of our treatment approach for upper back pain. We select exercises that are not only effective but also safe and suitable for your condition. These exercises aim to improve flexibility, strength, and endurance of the muscles around the thoracic spine. Here are 10 examples of exercises that may be included in your treatment plan:</p>
                    <p>
                        - Scapular retractions<br />
                        - Thoracic extensions<br />
                        - Upper back rotations<br />
                        - Shoulder blade squeezes<br />
                        - Rowing exercises<br />
                        - Wall angels<br />
                        - Cat-cow stretches<br />
                        - Child's pose<br />
                        - Foam roller stretches<br />
                        - Resistance band pull-aparts<br />
                    </p>
                </div>
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Pinloaded.webp" alt="Exercise" />
                    </div>
                    <div className="service-intro-content2">
                        <h1>Advanced Exercise Progressions</h1>
                        <p>As your condition improves, we may introduce more advanced exercises to further enhance the strength and stability of your upper back. These progressions are designed to challenge your muscles and ensure that you continue to make gains in your recovery.</p>
                        <p>Our physiotherapists will closely monitor your progress and adjust your exercise program accordingly, always prioritizing your comfort and safety.</p>

                        <br></br>
                        <p>
                            In conclusion, if you're struggling with upper back pain, Ramp Physio and Fitness is equipped to help you find relief and regain your quality of life. Our team is committed to providing you with the highest standard of care, utilizing evidence-based treatments and exercises. Don't let upper back pain hold you back any longer—book an appointment with us today and take the first step towards a pain-free future.
                        </p>
                    </div>
                </div>
            </SkewedContainer>
            <SubpagesLink />

            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default PhysiotherapyTreatmentAndExercisesForUpperBackPain;